var React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

module.exports = createClass({
  displayName: 'UnavailableSection',

  propTypes: {
    size: PropTypes.oneOf(['', 'vf-md-3', 'vf-md-4', 'vf-md-6', 'vf-md-8', 'vf-md-12']),
    className: PropTypes.string,
    beforeHeader: PropTypes.any,
    headerIcon: PropTypes.string,
    headerText: PropTypes.any,
    contentText: PropTypes.any,
    footerText: PropTypes.any,
    buttons: PropTypes.any
  },

  getDefaultProps() {
    return {
      size: 'vf-md-6',
      className: '',
      headerIcon: 'icon-disappointed-face',
      headerText: '',
      contentText: null,
      footerText: null,
      buttons: null
    };
  },

  render() {
    var {size, className, beforeHeader, headerIcon, headerText, contentText, footerText, buttons} = this.props;
    var classes = 'vf-unavailable-section vf-wrapper vf-text-center flex-1 flex-column flex-stretch ' + className;

    return (
      <div className={classes}>
        <div className='vf-row'>
          <div className='col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8'>
            <div>{beforeHeader}</div>

            <div className='vf-unavailable-section-header'>
              <i className={'vf-icon ' + headerIcon}></i>
              <h2 className='vf-font-bold'>{headerText}</h2>
            </div>

            <div className='vf-unavailable-section-data'>
              <div className='margin-top-1x'>{contentText}</div>
            </div>

            <div className='vf-unavailable-section-footer'>
              {footerText}
            </div>

            <div className='vf-unavailable-section-buttons'>
              {buttons}
            </div>
          </div>
          <div className={'flex-1 vf-unavailable-section-content ' + size}>

          </div>
        </div>
      </div>
    );
  }
});
